import React from "react";
import UspContent from "../components/pages/Content/UspContent";
import SideNav from "../components/SideNav/sideNav";
import Header from "../components/Header/hearder";
import { Wrapper } from "./layout.styles";

const UspContentLayout = () => {
  return (
    <React.Fragment>
      <Header />
      <Wrapper>
        <SideNav />
        <div style={{ margin: "70px 0px 0px 200px", width: "100%" }}>
          <UspContent />
        </div>
      </Wrapper>
    </React.Fragment>
  );
};

export default UspContentLayout;
